import { Component, OnInit } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-quick-access",
    templateUrl: "./quick-access.component.html",
    styleUrls: ["./quick-access.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class QuickAccessComponent implements OnInit {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<QuickAccessComponent>,
    private GTMSegment: GTMSegmentService) {
    this.GTMSegment.GTMPopupInitialization("Quick Access");
  }

  ngOnInit() { }

  back() {
    this.bottomSheetRef.dismiss();
  }
}
